export default `
... on entryBlocks_copy_BlockType {
  baseCopy
}
`;
